/**
 * Replaces "<br/>" tags with periods and removes all other HTML tags from the given text.
 * @param {string} text - The text to format.
 * @returns {string} - The formatted text.
 */
export const formatHTMLtoReadableText = (text) => text.replace('<br/>', '. ').replace(/<\/?[^>]+(>|$)/g, '');
